import {useMapEvent} from "react-leaflet";

const MapDragHandler = ({followSetting, pause}) => {
    useMapEvent("movestart", (event) => {
        if (followSetting.following && !pause.current) {
            pause.current = true;
            setTimeout(() => {
                pause.current = false;

            }, 3000);
        }

    });

    useMapEvent("zoomstart", (event) => {
        if (followSetting.following && !pause.current) {
            pause.current = true;
            setTimeout(() => {
                    pause.current = false;
                }
                , 2000);
        }
    })


    return null;
};
export default MapDragHandler;
